import { CodeSpinnerIcon } from "src/assets/icons";

const RedirectPage = () => {
  return (
    <CodeSpinnerIcon
      sx={{ position: "absolute", top: "calc(50% - 50px)", left: "calc(50% - 50px)", height: "100px", width: "100px" }}
    />
  );
};

export { RedirectPage };
